import api from "@/lib/api";

export default {
  getAll(cardId) {
    return api.get("/api/v1/planner/comment/get-all", { params: { any: cardId } });
  },
  create(cardId, note, userId) {
    return api.post("/api/v1/planner/comment/create", { note, cardId, userId });
  },
  update(id, note) {
    return api.put("/api/v1/planner/comment/update", { id, note });
  },
  remove(id) {
    const ids = Array.isArray(id) ? id.join(",") : id;
    return api.delete("/api/v1/planner/comment/delete", { params: { ids } });
  },
};

